export default class Edge {
  constructor (
    data
  ) {
    this.data = data
  }

  getFa2Value = (array) => {
    return array[this.v1index]
  }

  writeFa2Value = (value = 1, array) => {
    array[this.v1index] = value
  }

  writeSourceIndex = (index, array) => {
    array[this.v2index] = index
  }

  writeTargetIndex = (index, array) => {
    array[this.v2index + 1] = index
  }

  writeOpacity = (value, array) => {
    array[this.v1index] = value
  }

  writeWidth = (value, array) => {
    array[this.v1index] = value
  }

  setIndex = (index) => {
    this.v1index = index
    this.v2index = index * 2
  }
}
